import axios from 'axios'
import { globalStore } from '../main.js'
import { store } from '../store'


let BASE_URL = ""

export { getTeacherEfforts, getStudentEfforts, getList, getItem, getPeriods, 
  getClassesForTeacher, getStudentsForClass, postUserLogin , BASE_URL, putTeacherEffort, 
  putStudentEffort, getReportingPeriodClassId, getEffortTrackingStatus, 
  sendReminderFromAPI, getUserByIdentityId, putNewPassword, putResetPassword, resetUserPasswordToDefault, resetUsersPasswordToDefault,
  postForgotPassword, postPasswordRecovery, postRegisterAccount, postCsvFile, 
  getYearsAndCohorts, getFilteredStatus, getImportProgress, initialize, getAllDataAsCsv, 
  getExportProgress, getCsvFile, sendImportResults, getTeachersCount, 
  getStudentsCount, getClassesCount, getMissingReport, downloadFile, getMissingReportsCount,
  createFileWithStudentEfforts, createFileWithTeacherEfforts, getListByPeriod,
  postReportingPeriod, putReportingPeriod, postAcademicCsvFile, GetAcademicImportProgress,
  activatePeriod, deactivatePeriod, deleteClassFromPeriod, getPeriodHasEfforts, 
  getStudentPeriodHasEfforts, deletePeriod, makePeriodVisible,
  makePeriodComplete, makeClassOnline, getStudentClassesByPeriod, getTeacherClassesByPeriod,
  deleteStudentClass, showHideTeacherName, getShowingTeacherName, deleteTeacherClass,
  saveSettingAsImage, saveSettingAsText, getSettings, getSetting, getBackgroundImg, removeBackgroundImg,
  deleteSetting, saveSettings, saveGradingTabsSettings, getTabsSettings,
  getMyEffortsStudent, getMyEffortsTeacher, getGradingButtonsSettings,
  updateCourseWeighting, updateStudentTasks, updateTermWeighting,
  GetValuesForGauges, GetClassesForStudentDashboard, GetTeacherGraded,
  GetStudentGraded, GetChartData, getEffortScore, getDashboardCalculationStatus,
  GetDashboardDifferences, makePeriodIncomplete, stopDashboardCalculations,
  makePeriodInvisible, getReportingDates, getCompletedPeriods, 
  getStudentDashboardTotals, getStudent, createDashboardFile, createStudentsDashboardFile,
  sendPeriodCompleteNotification, createFileWithGradeSummary, 
  getActivePeriods, getHelpFile, getAllTeachers, postAddTeacherToClass,postChangePrimaryTeacherOfClass,
  getNonMiddleManagers, deleteClassManager, postClassManagerAssociation, 
  getManagerClasses, postMiddleManager, deleteMiddleManager, 
  getManagerTeachersByPeriod, getManagerAssociations, deleteAllAssociations,
  getClassesForMiddleManager, getMiddleManagerName, 
  postAllClassManagerAssociations, postMiddleManagerSettings,
  getMiddleManagersSettings, getAllClassesMiddleManagerAdmin, getManagerAssociationsByPeriod, createTeacher, getMotionChartInformation, getStudentMotionChartInformation,
  getActivePeriodsByUser, getVisiblePeriodsByUser, getDashboardDataCount, getAllUsersList, updateUserInfo, lockoutUser, unlockUser, addNewUser,
  getImageBySettingsKey, removeImageBySettingsKey, getReportingPeriodStatus, getClassesForStudentDashboardByPeriodId, getValuesForGaugesByPeriodId,
  getTeacherGradedByPeriodIdFromApi, getStudentGradedByPeriodIdFromApi, getDashboardDifferencesByPeriodId, getEffortScoreByPeriodIdFromApi,
  getChartDataByPeriodIdFromApi, getStudentDashboardTotalsByPeriodId, getCompletedAndVisiblePeriods
}

axios.interceptors.response.use((response) => { // intercept the global error
    return response
  }, function (error) {
  let originalRequest = error.config
  if ((error.response.status === 401 || error.response.status === 403)  && !originalRequest._retry) { // if the error is 401 and hasent already been retried
    originalRequest._retry = true
    store.commit('logout');
    window.location.href = '/#/users/login'
    return
  }
  // Do something with response error
  return Promise.reject(error)
})

function initialize() {
  return axios.get("/config.json.txt").then(response => {
    BASE_URL = response.data.baseUrl;
  });
}


function handleException(ex){
  return ex;
}

function getDataFromUrl(url){
  return axios.get(url, { headers: getAuthHeader() })
            .then(response => response.data)
            .catch(ex => handleException(ex))
  
}

function getAuthHeader(url, data){
  return {'Authorization': "bearer " + store.state.token }
}

function getConfig(){
  return {
    headers: {
       'Content-Type': 'application/json',
       'Authorization': "bearer " + store.state.token
    }
  }
}

function getTeacherEfforts (teacherId, classId) {
  var periodId = localStorage.getItem('period-selected');
  const url = `${BASE_URL}teacher-efforts/period/${periodId}/teacher/${teacherId}/class/${classId}/group-effort`
  return getDataFromUrl(url)
}

function getStudentEfforts (studentId) {
  var periodId = localStorage.getItem('period-selected');
  const url = `${BASE_URL}student-efforts/period/${periodId}/student/${studentId}/group-effort/group-class`
  return getDataFromUrl(url)
}

function getItem(what, id) {
  const url = `${BASE_URL}${what}/${id}`
  return getDataFromUrl(url)
}

function getList(what, pagination, filter) {
  return getListInternal(what, pagination.page, pagination.rowsPerPage, filter, pagination.sortBy, pagination.descending);
}

function getAllTeachers(filter) {
  
  var _filter = filter;

  if(filter)
    var _filter = filter.trim();

  var url = `${BASE_URL}teachers/all`
  console.log(url);
  return getDataFromUrl(url);
}

function getNonMiddleManagers(filter) {
  
  var _filter = filter;

  if(filter)
    var _filter = filter.trim();
  
    var url = `${BASE_URL}middlemanagers/nonmiddlemanagers`
  console.log(url);
  return getDataFromUrl(url);
}

// function getTeachersMiddleManager(filter) {
//   var _filter = filter.trim();
//   var url = `${BASE_URL}middlemanagers/allteachers`
//   console.log(url);
//   return getDataFromUrl(url);
// }

function getListByPeriod(what, pagination, filter) {
  return getListInternalByPeriod(what, pagination.page, pagination.rowsPerPage, filter, pagination.sortBy, pagination.descending)
}



function getListInternal (what, page, pageSize, filter, sortBy, descending) {
  var url = `${BASE_URL}${what}/all/${page}?pageSize=${pageSize}`

  if(filter){
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }
  if(sortBy){
    url += `&sortBy=${sortBy}`
  }
  if(descending){
    url += `&descending=${descending}`
  }
  return getDataFromUrl(url)
}



function getListInternal (what, page, pageSize, filter, sortBy, descending) {
  var url = `${BASE_URL}${what}/all/${page}?pageSize=${pageSize}`
  if(filter){
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }
  if(sortBy){
    url += `&sortBy=${sortBy}`
  }
  if(descending){
    url += `&descending=${descending}`
  }
  return getDataFromUrl(url)
}

function getListInternalByPeriod(what, page, pageSize, filter, sortBy, descending)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}${what}/getbyperiod/${periodId}/${page}?pageSize=${pageSize}`

  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }

  if (sortBy)
    url += `&sortBy=${sortBy}`

  if (descending)
    url += `&descending=${descending}`

  return getDataFromUrl(url);

}


function getPeriods(){
  var url = `${BASE_URL}periods/all`;
  return getDataFromUrl(url).then(response => response )
}

function getClassesForTeacher(teacherId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}teachers/${teacherId}/period/${periodId}/classes`;
  
  return getDataFromUrl(url)
}

function getStudentsForClass(classId, teacherId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classes/${classId}/period/${periodId}/teacher/${teacherId}/students`;

  return getDataFromUrl(url)
}

function postUserLogin(user, password){
  var url = `${BASE_URL}auth/login`;

  let data = JSON.stringify({
    Password: password,
    User: user
  })

  return axios
    .post(url, data,  getConfig() )
    .then(response => response)
    .catch(ex => handleException(ex));
}

function putTeacherEffort(teacherEffort){
  var url = `${BASE_URL}teacher-efforts/update`;
  var newData = JSON.stringify(teacherEffort);

  return axios
  .put(url, newData,  getConfig())
  .then(response => response.data)
  .catch( ex => handleException(ex))
}

function putStudentEffort(studentEffort){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}student-efforts/update/${periodId}`;
  var newData = JSON.stringify(studentEffort);

  return axios
  .put(url, newData,  getConfig() )
  .then(response => response.data)
  .catch( ex => handleException(ex) )
}

function getReportingPeriodClassId(classId, periodId) {
  var url = `${BASE_URL}classes/${classId}/period/${periodId}`;
  
  return axios
  .get(url, getConfig() )
  .then(response => response.data)
}


function getEffortTrackingStatus() {
  var url = `${BASE_URL}status/${globalStore.selectedPeriod}`;
  return getDataFromUrl(url);
}

function getFilteredStatus(role, year, cohort) {
  if (typeof year == "null")
    year = "null";
  
  if (typeof cohort == "null")
    cohort = "null";

  var url = `${BASE_URL}status/${globalStore.selectedPeriod}/${role}/${year}/${cohort}`;
  return getDataFromUrl(url);
}

function sendReminderFromAPI(recipients, subject, message){
  var url = `${BASE_URL}status/sendreminder`;
  let data = JSON.stringify({
    Emails: recipients,
    Subject: subject,
    Message: message
  })

  // test Data
  var testData = "{'Emails':['support@cosource.com.au'],'Subject': '" + subject +"', 'Message': '"+ message +"'}";
  
  return axios
  .post(url, data,  getConfig())
  .then(response => response.data)
}

function getUserByIdentityId(identityId){
  var url = `${BASE_URL}accounts/${ identityId }`;
  return getDataFromUrl(url);
}

function putNewPassword(newPasswordModel) {
  var url = `${BASE_URL}accounts`;

  return axios
  .put(url, newPasswordModel,  getConfig())
  .then(response => response)
  .catch( ex => handleException(ex) );
}

function putResetPassword(model) {
  var url = `${BASE_URL}accounts/resetpassword/true`;

  return axios 
  .put(url, model,  getConfig())
  .then( response => response )
  .catch( ex => handleException(ex) );
}

function resetUserPasswordToDefault(userType, email)
{
  var url = `${BASE_URL}accounts/resetuserpasswordtodefault/${userType}/${email}`;

  console.log(userType + ": " + email);

  return axios 
     .post(url, "",  getConfig())
     .then( response => response )
     .catch( ex => handleException(ex) );
}

function resetUsersPasswordToDefault(userType, prevDefaultPassword)
{
  var url = `${BASE_URL}accounts/resetuserspasswordtodefault/${userType}`;

  console.log(userType);

  return axios 
     .post(url, prevDefaultPassword,  getConfig())
     .then( response => response )
     .catch( ex => handleException(ex) );
}

function postForgotPassword(email) {
  var url = `${BASE_URL}accounts/forgotpassword`;

  console.log(url);

  return axios
  .post(url, email,  getConfig())
  .then(response => response )
  .catch( ex => handleException(ex) );
}

function postPasswordRecovery(model) {
  var url = `${BASE_URL}accounts/passwordrecovery`;
  console.log(BASE_URL);
  console.log(url);

  return axios
  .post(url, model,  getConfig())
  .then(response => response )
  .catch(ex => handleException(ex));
}

function postRegisterAccount(model) {
  var url = `${BASE_URL}accounts/register`;
  
  return axios
  .post(url, model,  getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function postCsvFile(file, option) {
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}datamanagement/upload/option/${option}/period/${periodId}`;
  
  var formData = new FormData();
  formData.append("csv", file[0]);

  return axios
  .post(url, formData, { headers: {'Accept' : 'application/json' ,  'Authorization': "bearer " + store.state.token }} )
  .then(response => response)
  
}

function postAcademicCsvFile(file, option){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}datamanagement/upload/academic/period/${periodId}`;

  var formData = new FormData();
  formData.append("csv", file[0]);

  return axios
  .post(url, formData, { headers: {'Accepr' : 'application/json', 'Authorization': "bearer " + store.state.token }} )
  .then(response => response)
  .catch( ex => handleException(ex));
}

function getAllDataAsCsv(periodId) {
  var url = `${BASE_URL}datamanagement/getalldata/` + periodId;

  return getDataFromUrl(url);
}

function getImportProgress(){
  var url = `${BASE_URL}datamanagement/status`;
  return getDataFromUrl(url);
}

function GetAcademicImportProgress() {
  var url = `${BASE_URL}datamanagement/academicstatus`;
  return getDataFromUrl(url);
}

function getExportProgress(){
  var url = `${BASE_URL}datamanagement/exportstatus`;
  return getDataFromUrl(url);
}

function getYearsAndCohorts(periodId) {
  var url = `${BASE_URL}status/period/${periodId}/yearsandcohorts`;
  return getDataFromUrl(url);
}

function getCsvFile(fileName) {
  var url = `${BASE_URL}datamanagement/getfile/${fileName}`;
  return url;
}

function sendImportResults(recipients, report){
  var url = `${BASE_URL}datamanagement/sendimportresults`;
  let data = JSON.stringify({
    Emails: recipients,
    Message: report
  })

  return axios
  .post(url, data,  getConfig())
  .then(response => response.data)
}

function getTeachersCount(periodId) {
  var url = `${BASE_URL}teachers/count/period/${periodId}`;
  return getDataFromUrl(url);
}

function getStudentsCount(periodId) {
  var url = `${BASE_URL}students/count/period/${periodId}`;
  return getDataFromUrl(url);
}

function getClassesCount(periodId) {
  var url = `${BASE_URL}classes/count/period/${periodId}`;
  return getDataFromUrl(url);
}

function getMissingReport(periodId) {
  var url = `${BASE_URL}status/missing/${periodId}`;
  return getDataFromUrl(url);
}

function getMissingReportsCount(periodId, teacherId) {
  var url = `${BASE_URL}missing-efforts/period/${periodId}/teacher/${teacherId}`;
  return getDataFromUrl(url);
}

function getPeriodHasEfforts(periodId, teacherId) {
  var url = `${BASE_URL}period-hasefforts/period/${periodId}/teacher/${teacherId}`;
  return getDataFromUrl(url);
}

function getStudentPeriodHasEfforts(periodId, studentId) {
  var url = `${BASE_URL}studentperiod-hasefforts/period/${periodId}/student/${studentId}`;
  return getDataFromUrl(url);
}

function createFileWithStudentEfforts(studentId, periodId) {
  var url = `${BASE_URL}datamanagement/createfilestudent/${studentId}/${periodId}`;
  return getDataFromUrl(url);
}

function createFileWithTeacherEfforts(teacherId, classId, periodId) {
  var url = `${BASE_URL}datamanagement/createfileteacher/${teacherId}/${classId}/${periodId}`;
  return getDataFromUrl(url);
}

function createFileWithGradeSummary(userId, periodId, usertype)
{
  var url = `${BASE_URL}datamanagement/createfilegradesummary/${userId}/${periodId}/${usertype}`;
  return getDataFromUrl(url);
}

function postReportingPeriod(period) {
  var url = `${BASE_URL}periods/add`;
  let data = JSON.stringify({
    Id: 0,
    Name: period.name,
    StartDate: period.startDate,
    EndDate: period.endDate
  });

  return axios.post(url, data, getConfig())
    .then(response => response)
    .catch(ex => handleException(ex));

}

function activatePeriod( periodId ) {
  var url = `${BASE_URL}periods/activate/${periodId}`;
  return axios
  .post(url, "", getConfig())
  .then(result => result)
  .catch(ex => handleException(ex));
}

function deactivatePeriod( periodId ) {
  var url = `${BASE_URL}periods/deactivate/${periodId}`;
  return axios
  .post(url, "", getConfig())
  .then(result => result)
  .catch(ex => handleException(ex));
}

function makePeriodVisible(periodId) {
  var url = `${BASE_URL}periods/makevisible/${periodId}`;

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex => handleException(ex));
}

function makePeriodInvisible(periodId) {
  var url = `${BASE_URL}periods/makeinvisible/${periodId}`;

  console.log(url);
  return axios.post(url, "", getConfig()).then(result => result).catch(ex => handleException(ex));
}

function makePeriodComplete(period, reportingDate) {

  var url = `${BASE_URL}periods/makecomplete`;

  var periodModel = JSON.stringify({
    Id: period.id,
    Name: period.name,
    //StartDate: period.startDate,
    //EndDate: period.endDate,
    ReportingDate: reportingDate
  });

  return axios.post(url, periodModel, getConfig())
  .then(result => result)
  .catch(ex => handleException(ex));
}

function makePeriodIncomplete(periodId) {
  var url = `${BASE_URL}periods/makeincomplete/${periodId}`;

  return axios.post(url, "", getConfig())
  .then(result => result).catch(ex => handleException(ex));
}

function putReportingPeriod(period) {
  var url = `${BASE_URL}periods/edit/${period.id}`;
  let data = JSON.stringify({
    Id: period.id,
    Name: period.name,
    StartDate: period.startDate,
    EndDate: period.endDate,
    Active: period.active
  });

  return axios.put(url, data, getConfig())
    .then(response => response)
    .catch(ex => handleException(ex));

}

function deleteClassFromPeriod(classId, periodId) {
  var url = `${BASE_URL}classes/remove/${classId}/${periodId}`;

  return axios.delete(url, getConfig())
    .then(response => response)
    .catch(ex => handleException(ex));
}

function deletePeriod(periodId) {
  var url = `${BASE_URL}periods/delete/${periodId}`;
  console.log(url);

  return axios.delete(url, getConfig())
  .then(result => result)
  .catch(ex => handleException(ex));
}

function makeClassOnline(classId, periodId, online) {
  var url = `${BASE_URL}classes/makeonline/${classId}/period/${periodId}/${online}`;

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function showHideTeacherName(value) {
  //var url = `${BASE_URL}classes/showhideteachername/${periodId}`;
  var url = `${BASE_URL}settings/showhideteachername/${value}`;

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function getStudentClassesByPeriod(classId, pagination, filter)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}studentclasses/getbyperiod/${classId}/${periodId}/${pagination.page}?pageSize=${pagination.rowsPerPage}`

  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }

  if (pagination.sortBy)
    url += `&sortBy=${pagination.sortBy}`

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  return getDataFromUrl(url);

}

function getTeacherClassesByPeriod(classId, pagination, filter)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}teacherclasses/getbyperiod/${classId}/${periodId}/${pagination.page}?pageSize=${pagination.rowsPerPage}`

  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }

  if (pagination.sortBy)
    url += `&sortBy=${pagination.sortBy}`

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  return getDataFromUrl(url);

}

function getShowingTeacherName()
{
  var url = `${BASE_URL}settings/getshowteachername`;

  return getDataFromUrl(url);
}

function deleteStudentClass(rpcId, studentId)
{
  var url = `${BASE_URL}studentclasses/${rpcId}/${studentId}`;

  return axios.delete(url, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function deleteTeacherClass(classId, teacherId)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}teacherclasses/${periodId}/${classId}/${teacherId}`;

  return axios.delete(url, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function deleteMiddleManager(teacherId)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}middlemanagers/${teacherId}`;

  return axios.delete(url, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}


function saveSettingAsImage(data){
  var url = `${BASE_URL}settings/saveimage`;
  
  return axios.post(url, 
            data, {
            headers: {'Content-Type': 'multipart/form-data', 'Authorization': "bearer " + store.state.token}
        }).then( response => response ).catch(ex =>handleException(ex));
}

function saveSettingAsText(data) {
  var url = `${BASE_URL}settings/savetext`;

  return axios.post(url, data, { headers: {'Content-Type': 'multipart/form-data', 'Authorization': "bearer " + store.state.token }})
  .then(response => response)
  .catch(ex => handleException(ex));
}

function getSettings() {
  var url = `${BASE_URL}settings/getsettings`;
  return getDataFromUrl(url);
}

function getGradingButtonsSettings() {
  var url = `${BASE_URL}settings/getgradigbuttonssettings`;
  return getDataFromUrl(url);
}

function getSetting(key)
{
  var url = `${BASE_URL}settings/getsetting/${key}`;
  return getDataFromUrl(url);
}

function getBackgroundImg()
{
  var url = `${BASE_URL}settings/GetBackgroundImg`;
  return getDataFromUrl(url);
}

function removeBackgroundImg()
{
  var url = `${BASE_URL}settings/RemoveBackgroundImg`;
  return getDataFromUrl(url);
}

function deleteSetting(id) 
{
  var url = `${BASE_URL}settings/${id}`;
  return axios.delete(url, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function saveSettings(settings) {
  var url = `${BASE_URL}settings/savesettings`;

  return axios.post(url, settings, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function saveGradingTabsSettings(settings) {
  var url = `${BASE_URL}settings/gradingtabssettings`;

  return axios.post(url, settings, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function getTabsSettings() {
  var url = `${BASE_URL}settings/gradingtabssettings`;
  return getDataFromUrl(url);
}

function getMyEffortsStudent(studentId, pagination, filter) {
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}student-efforts/period/${periodId}/student/${studentId}/all?sortBy=${pagination.sortBy}`
  
  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  console.log(url);
  
  return getDataFromUrl(url);
}

function getMyEffortsTeacher(teacherId, pagination, filter) {
  
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}teacher-efforts/period/${periodId}/teacher/${teacherId}/all?sortBy=${pagination.sortBy}`
  
  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  if (pagination.page)
    url += `&page=${pagination.page}`

  if (pagination.rowsPerPage)
    url += `&pageSize=${pagination.rowsPerPage}`

  console.log(url);
  
  return getDataFromUrl(url);
}

function updateCourseWeighting(courseId, weighting) {
  var url = `${BASE_URL}courses/updateweighting/${courseId}/${weighting}`;

  return axios.post(url, "", getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function updateStudentTasks(tasks) {
  // StudentTasks
  var url =  `${BASE_URL}studenttasks`;
  var data = JSON.stringify(tasks);

  console.log(data);
  return axios.post(url, data, getConfig()).then(response => response).catch(ex => handleException(ex));
}

function updateTermWeighting(termNumber, weighting) {
  var url = `${BASE_URL}tasks/updateweighting`;
  let data = JSON.stringify({
    TermNumber: termNumber,
    TermWeighting: weighting
  })

  //console.log(data);

  return axios.post(url, data, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function GetValuesForGauges(studentId, reportingDate) {
  var url = `${BASE_URL}studentdashboard/getgauges/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}

function getValuesForGaugesByPeriodId(studentId, dashboardPeriodId) {
  var url = `${BASE_URL}studentdashboard/getgaugesbyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}


function GetClassesForStudentDashboard(studentId, reportingDate) {
  var url = `${BASE_URL}studentdashboard/getclasses/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}

function getClassesForStudentDashboardByPeriodId(studentId, dashboardPeriodId) {
  var url = `${BASE_URL}studentdashboard/getclassesbyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}


function GetTeacherGraded(studentId, reportingDate)
{
  var url = `${BASE_URL}studentdashboard/getteachergraded/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}

function getTeacherGradedByPeriodIdFromApi(studentId, dashboardPeriodId)
{
  var url = `${BASE_URL}studentdashboard/getteachergradedbyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}


function GetStudentGraded(studentId, reportingDate) {
  var url = `${BASE_URL}studentdashboard/getstudentgraded/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}

function getStudentGradedByPeriodIdFromApi(studentId, dashboardPeriodId) {
  var url = `${BASE_URL}studentdashboard/getstudentgradedbyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}

function GetChartData(studentId, reportingDate) {
  var url = `${BASE_URL}studentdashboard/getchartdata/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}

function getChartDataByPeriodIdFromApi(studentId, dashboardPeriodId) {
  var url = `${BASE_URL}studentdashboard/getchartdatabyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}

function getEffortScore(studentId, reportingDate) {
  var url = `${BASE_URL}studentdashboard/geteffortscore/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}


function getEffortScoreByPeriodIdFromApi(studentId, dashboardPeriodId) {
  var url = `${BASE_URL}studentdashboard/geteffortscorebyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}

function getDashboardCalculationStatus(){
  var url = `${BASE_URL}periods/getcalculationstatus`;
  return getDataFromUrl(url);
}

function GetDashboardDifferences(studentId, reportingDate) {
  var url = `${BASE_URL}studentdashboard/getdifferences/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}

function getDashboardDifferencesByPeriodId(studentId, dashboardPeriodId) {
  var url = `${BASE_URL}studentdashboard/getdifferencesbyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}

function stopDashboardCalculations(periodId) {
  var url = `${BASE_URL}periods/stopdashboardcalculations/${periodId}`;

  return axios.post(url, "", getConfig()).then(response => response).catch(ex => handleException(ex));
}

function getReportingDates(studentId) {
  var url = `${BASE_URL}studentdashboard/getreportingdates/${studentId}`;
  return getDataFromUrl(url);
}

function getCompletedPeriods(studentId){
  var url = `${BASE_URL}students/getcompletedperiods/${studentId}`;
  return getDataFromUrl(url);
  
}

function getActivePeriods(studentId){
  var url = `${BASE_URL}students/getactiveperiods/${studentId}`;
  return getDataFromUrl(url);
  
}

function getStudentDashboardTotals(studentId, reportingDate)
{
  var url = `${BASE_URL}studentdashboard/totals/${studentId}/${reportingDate}`;
  return getDataFromUrl(url);
}


function getStudentDashboardTotalsByPeriodId(studentId, dashboardPeriodId)
{
  var url = `${BASE_URL}studentdashboard/totalsbyperiod/${studentId}/${dashboardPeriodId}`;
  return getDataFromUrl(url);
}

function getStudent(studentId)
{
  var url = `${BASE_URL}students/${studentId}`;
  return getDataFromUrl(url);
}

function createDashboardFile(studentId, reportingDate)
{
  var url = `${BASE_URL}datamanagement/getdashboarddata/${studentId}`;
  return getDataFromUrl(url);
}

function createStudentsDashboardFile(periodId)
{
  var url = `${BASE_URL}datamanagement/getstudentsdashboarddata/${periodId}`;
  return getDataFromUrl(url);
}

function getDashboardDataCount(periodId)
{
  var url = `${BASE_URL}datamanagement/getdashboarddatacount/${periodId}`;
  return getDataFromUrl(url);
}

function sendPeriodCompleteNotification(subject, message, periodId) {
  var url = `${BASE_URL}periods/sendnotification/${periodId}`;
  let data = JSON.stringify({
    Subject: subject,
    Message: message
  });

  console.log(data);
  
  return axios
  .post(url, data,  getConfig())
  .then(response => response.data)
}

function getCsvFile(fileName) {
  var url = `${BASE_URL}datamanagement/getfile/${fileName}`;
  return url;
}

async function downloadFile(url, fileName) {
  axios({
    url: url,
    method: 'GET',
    responseType: 'blob',
    headers: getAuthHeader()
  }).then( response => {
    console.log(response);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
}

async function getHelpFile(usertype) {

  if (usertype == 'middlemanager')
    usertype = 'teacher';

  var url = `${BASE_URL}datamanagement/gethelpfile/${usertype}`;

  axios({ url:  url, method: 'GET', responseType: 'blob', headers: getAuthHeader() })
  .then(result => { 
    console.log(result);
    var file = new Blob([result.data], { type: "application/pdf" })
    const url = window.URL.createObjectURL(file);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', '_blank');
    link.view = "EffortTracking-help.pdf";
    link.click();
  }).catch(error => console.log(error));
}


function postAddTeacherToClass(classId, teacherId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}teacherclasses/addteachertoclass/${periodId}/${classId}/${teacherId}`;

  //var url = `${BASE_URL}classes/showhideteachername/${periodId}`;

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));

}

function postChangePrimaryTeacherOfClass(classId, teacherId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}teacherclasses/changeprimaryteacherofclass/${periodId}/${classId}/${teacherId}`; 

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function postMiddleManager(teacherId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}middlemanagers/addmiddlemanager/${teacherId}`; 

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function postClassManagerAssociation(classId, middleManagerId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classmanagers/addassociation/${periodId}/${classId}/${middleManagerId}`; 

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function getManagerAssociations(pagination, middleManagerId, filter)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classmanagers/getmanagerassociations/${middleManagerId}/${periodId}/${pagination.page}?pageSize=${pagination.rowsPerPage}`

  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }    

  if (pagination.sortBy)
    url += `&sortBy=${pagination.sortBy}`

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  console.log(url);
  return getDataFromUrl(url);
}

function getManagerAssociationsByPeriod(pagination, middleManagerId, filter)
{
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classmanagers/getmanagerassociationsbyperiod/${middleManagerId}/${periodId}/${pagination.page}?pageSize=${pagination.rowsPerPage}`

  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }    

  if (pagination.sortBy)
    url += `&sortBy=${pagination.sortBy}`

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  console.log(url);
  return getDataFromUrl(url);
}


function deleteClassManager(classId, middleManagerId)
{
  var url = `${BASE_URL}classmanagers/${classId}/${middleManagerId}`;

  return axios.delete(url, getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function getManagerTeachersByPeriod(middleManagerId, pagination, filter)
{
  // var _filter = filter.trim();
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classmanagers/getteachers/${middleManagerId}/${periodId}/${pagination.page}?pageSize=${pagination.pageSize}`

  if(filter)
    url += `&filter=${_filter}`

  // if (pagination.sortBy)
  //   url += `&sortBy=${sortBy}`

  // if (pagination.descending)
  //   url += `&descending=${descending}`

  return getDataFromUrl(url);

}

function getManagerClasses(middleManagerId, pagination, filter)
{
  console.log('PAGINATION:');
  console.log(pagination);
    
    var periodId = localStorage.getItem('period-selected');
    var url = `${BASE_URL}classmanagers/getclasses/${middleManagerId}/${periodId}/${pagination.page}?pageSize=${pagination.pageSize}`
  
    if(filter)
    {
      var _filter = filter.trim();
      url += `&filter=${_filter}`
    }
  
    if (pagination.sortBy)
      url += `&sortBy=${pagination.sortBy}`
  
    if (pagination.descending)
      url += `&descending=${pagination.descending}`
  
    return getDataFromUrl(url);

}

function deleteAllAssociations(middleManagerId, _classes)
{
  var url = `${BASE_URL}classmanagers/deleteallassociations/${middleManagerId}`;
  var periodId = localStorage.getItem('period-selected');
  
  let data = JSON.stringify({
    PeriodId: periodId,
    MiddleManagerId: middleManagerId,
    Classes: _classes
  })

  //console.log(data);
  console.log('DELETING ALL ASSOCIATIONS');
  
  return axios.post(url, data, getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));

  // return axios.delete(url, {
  //   headers: {
  //     Authorization: getConfig()
  //   },
  //   data: {
  //     model: data
  //   }
  // }).then(response => response).catch(ex => handleException(ex));

  // return axios.delete(url, data, getConfig())
  // .then(response => response)
  // .catch(ex => handleException(ex));
}

function getClassesForMiddleManager(middleManagerId, teacherId){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classmanagers/getclassesforgrading/${middleManagerId}/${teacherId}/period/${periodId}/classes`;
  
  return getDataFromUrl(url)
}

function getMiddleManagerName(middleManagerId){
  var url = `${BASE_URL}classmanagers/getmiddlemanagername/${middleManagerId}`;
  return getDataFromUrl(url);
}

function postAllClassManagerAssociations(middleManagerId, _classes){
  console.log(_classes);
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}classmanagers/addallassociations/${periodId}/${middleManagerId}`; 
  console.log(url);

  let data = JSON.stringify({
    PeriodId: periodId,
    MiddleManagerId: middleManagerId,
    Classes: _classes
  })

  // let data = JSON.stringify({
  //   Emails: recipients,
  //   Message: report
  // })

  console.log(data);

  return axios.post(url, data, getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function postMiddleManagerSettings(key, value){
  var url = `${BASE_URL}settings/middlemanagersettings/${key}/${value}`; 

  return axios.post(url, "", getConfig())
  .then(result => result)
  .catch(ex  => handleException(ex));
}

function getMiddleManagersSettings() {
  var url = `${BASE_URL}settings/getmiddlemanagerssettings`;
  return getDataFromUrl(url);
}

function getAllClassesMiddleManagerAdmin(pagination, filter)
{
  console.log(pagination);
  
  var url = `${BASE_URL}classmanagers/getallclasses/${pagination.page}?pageSize=${pagination.rowsPerPage}`

  if(filter)
  {
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }

  if (pagination.sortBy)
    url += `&sortBy=${pagination.sortBy}`

  if (pagination.descending)
    url += `&descending=${pagination.descending}`

  console.log(url);
  return getDataFromUrl(url);

}

function createTeacher(model) {
  var url = `${BASE_URL}teachers/create`;
  
  console.log(model);

  return axios
  .post(url, model,  getConfig())
  .then(response => response)
  .catch(ex => handleException(ex));
}

function getMotionChartInformation(studentId)
{
  if (studentId != null)
    var url = `${BASE_URL}studentmotionchart/getchartdata/${studentId}`;
  else
    var url = `${BASE_URL}teachermotionchart/getchartdata`;
  
  return getDataFromUrl(url);
}

function getStudentMotionChartInformation(studentId)
{
    var url = `${BASE_URL}teachermotionchart/getchartdata/${studentId}`;
  
    return getDataFromUrl(url);
}


function getActivePeriodsByUser(userId, usertype){
  var url = `${BASE_URL}periods/getactiveperiodsbyuser/${userId}/${usertype}`;
  return getDataFromUrl(url);
}

function getVisiblePeriodsByUser(userId, usertype){
  var url = `${BASE_URL}periods/getvisibleperiodsbyuser/${userId}/${usertype}`;
  return getDataFromUrl(url);
}


function getAllUsersList(pagination, filter) {
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}accounts/users/${periodId}/${pagination.page}?pageSize=${pagination.pageSize}`

  if(filter){
    var _filter = filter.trim();
    url += `&filter=${_filter}`
  }
  if(pagination.sortBy){
    url += `&sortBy=${pagination.sortBy}`
  }
  if(pagination.descending){
    url += `&descending=${pagination.descending}`
  }
  return getDataFromUrl(url)
}

function updateUserInfo(userData){
  var url = `${BASE_URL}accounts/updateuserinfo`;

  let data = JSON.stringify({
    UserId: userData.id,
    Role: userData.role,
    FirstName: userData.firstName,
    LastName: userData.lastName,
    Email: userData.email,
    Active: userData.active
  });
  
  return axios
    .post(url, data,  getConfig() )
    .then(response => response)
    .catch(ex => handleException(ex));
}

function lockoutUser(userData){
  var url = `${BASE_URL}accounts/lockoutuser`;

  let data = JSON.stringify({
    UserId: userData.id
  })
  
  return axios
    .post(url, data,  getConfig() )
    .then(response => response)
    .catch(ex => handleException(ex));
}

function unlockUser(userData){
  var url = `${BASE_URL}accounts/unlockuser`;

  let data = JSON.stringify({
    UserId: userData.id
  })
  
  return axios
    .post(url, data,  getConfig() )
    .then(response => response)
    .catch(ex => handleException(ex));
}


function addNewUser(newUserData){
  var url = `${BASE_URL}accounts/addnewuser`;

  return axios
    .post(url, newUserData,  getConfig() )
    .then(response => response)
    .catch(ex => handleException(ex));
}

function getImageBySettingsKey(key)
{
  var url = `${BASE_URL}settings/getimagebysettingskey/${key}`;
  return getDataFromUrl(url);
}

function removeImageBySettingsKey(key)
{
  var url = `${BASE_URL}settings/removeimagebysettingskey/${key}`;
  return getDataFromUrl(url);
}

function getReportingPeriodStatus(){
  var periodId = localStorage.getItem('period-selected');
  var url = `${BASE_URL}periods/status/${periodId}`;

  return getDataFromUrl(url)
}

function getCompletedAndVisiblePeriods(studentId){
  var url = `${BASE_URL}students/getcompletedandvisibleperiods/${studentId}`;
  return getDataFromUrl(url);
  
}



// WEBPACK FOOTER //
// ./src/utils/effort-tracking-api.js